import type { CSSProperties } from "react";
import { LoadingGlobe, type LoadingGlobePhase } from "./LoadingGlobe";

interface LoadingGlobeStageProps {
  phase?: LoadingGlobePhase;
  density?: number;
  className?: string;
  style?: CSSProperties;
}

export function LoadingGlobeStage({
  phase = "idle",
  density = 1,
  className,
  style,
}: LoadingGlobeStageProps) {
  return (
    <>
      <style>{loadingGlobeStageCss}</style>
      <div
        className={`fintheon-loading-globe-stage${className ? ` ${className}` : ""}`}
        data-loading-globe-stage="true"
        style={style}
      >
        <LoadingGlobe phase={phase} density={density} />
      </div>
    </>
  );
}

const loadingGlobeStageCss = `
  .fintheon-loading-globe-stage {
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    width: min(74vmin, calc(100vw - 40px), calc(100svh - 180px), 820px);
    height: min(74vmin, calc(100vw - 40px), calc(100svh - 180px), 820px);
    overflow: hidden;
    pointer-events: none;
    opacity: var(--fintheon-globe-stage-opacity, 0.94);
    filter: blur(0.28px) saturate(1.04) contrast(1.04);
    transform: translate(-50%, -50%);
    transition: opacity 560ms cubic-bezier(0.16, 1, 0.3, 1), filter 560ms cubic-bezier(0.16, 1, 0.3, 1);
    -webkit-mask-image: radial-gradient(circle at center, #000 0 54%, rgba(0, 0, 0, 0.94) 64%, rgba(0, 0, 0, 0.52) 76%, transparent 100%);
    mask-image: radial-gradient(circle at center, #000 0 54%, rgba(0, 0, 0, 0.94) 64%, rgba(0, 0, 0, 0.52) 76%, transparent 100%);
  }

  @media (max-width: 720px) {
    .fintheon-loading-globe-stage {
      width: min(82vw, calc(100svh - 220px), 520px);
      height: min(82vw, calc(100svh - 220px), 520px);
      --fintheon-globe-stage-opacity: 0.76;
    }
  }

  @media (max-height: 700px) {
    .fintheon-loading-globe-stage {
      width: min(68vmin, calc(100vw - 40px), calc(100svh - 132px), 620px);
      height: min(68vmin, calc(100vw - 40px), calc(100svh - 132px), 620px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .fintheon-loading-globe-stage { transition: none; }
  }
`;
